@import "styles/variables";

.radio-container {
  position: relative;
  margin-top: 6px;
  z-index: 1;
}

.radio-button {
  display: inline-block;
}

.radio-button .indicator {
  position: relative;
  display: inline-block;
  height: 16px;
  width: 16px;
  vertical-align: middle;
  background-color: var(--color-white);
  border: solid 1px var(--color-grey);
  border-radius: 50%;
}

.radio-button input {
  position: absolute;
  opacity: 0;
  z-index: -1;
}

.radio-button input:focus ~ label .indicator {
  border-color: var(--color-yellow);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
}

.radio-button input:checked ~ label .indicator {
  background: var(--color-yellow);
  border-color: var(--color-yellow);
}

.radio-button input:checked ~ label .indicator:after {
  display: block;
  position: absolute;
  content: '';
  top: 5px;
  left: 5px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: black;
}

.radio-button label {
  cursor: pointer;
  line-height: 36px;
  user-select: none;
}

.radio-text {
  margin-left: 5px;
  font-family: var(--font-stack-default);
  font-size: 14px;
  color: #212121;
  font-weight: 400;
  opacity: .6;
  user-select: none;
}

.radio-button + .radio-button {
  margin-left: 10px;
}

.no-error {
  display: none;
}

.has-error {
  display: block;
}

.error {
  position: absolute;
  border-radius: 2px;
  font-family: var(--font-stack-bold);
  font-size: 11px;
  color: white;
  box-sizing: border-box;
  background: #fe4545;
  padding: 7px 10px 9px;
  white-space: nowrap;
  top: calc(50%);
  right: 5px;
  transform: translate(calc(100% + 20px), -50%);
  z-index: 99;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.25);
}

.error > div {
  position: absolute;
  left: -7px;
  top: 50%;
  width: 0;
  height: 0;
  transform: translateY(-50%);
  border-style: solid;
  border-width: 6px 8px 6px 0;
  border-color: transparent #fe4545 transparent transparent;
}
